import { FC, ReactNode } from "react";
import { Paper, PaperProps } from "@mantine/core";

interface CardContainerProps extends Omit<PaperProps, "radius" | "withBorder"> {
  children: ReactNode;
  noPadding?: boolean;
}

export const CardContainer: FC<CardContainerProps> = ({
  children,
  noPadding = false,
  ...props
}) => {
  return (
    <Paper radius="md" p={noPadding ? 0 : "md"} withBorder {...props}>
      {children}
    </Paper>
  );
};
